/************************************************************
 Inpatient Namespace
 ************************************************************/

window.inpatientNS = {

    _action:null,
    _callback:null,
    _row:null,
    // Execute Action
    executeAction:function (action, row, callback) {
        var wfId = parseInt(action.wf_id),
            actionId = parseInt(action.wf_action_id);

        debug.log('Inpatient NS action',action);

        this._action = action;
        this._callback = callback;
        this._row = row;


        // Cancel Requisition
        if (actionId == 3) {
            inpatientNS.openReason(inpatientNS.cancelReasonModalHandler);
        }
        // Reject
        else if(actionId == 47){
            inpatientNS.openReason(inpatientNS.rejectReasonModalHandler);
        }
        // Plan
        else if(actionId == 48){
            Hades.loadShortcut(49, {id: inpatientNS._action.task_id, wf_action_id:inpatientNS._action.wf_action_id, wf_status_id:inpatientNS._action.to_state_id, type:'inpatient_treatment'});
        }
        // Admit
        else if(actionId == 50){
            Hades.loadShortcut(48, {id: inpatientNS._action.task_id, wf_action_id:inpatientNS._action.wf_action_id, wf_status_id:inpatientNS._action.to_state_id, type:'inpatient_treatment'});
        }
        // CheckIn
        else if (actionId == 54 || actionId == 129) {
            inpatientTemporaryExitNS.executeAction(this._action, this._row, this._callback);
        }
        // Administrative Discharge
        else if (actionId == 51) {
                inpatientNS.isSurgeryOpenValidateDischarge();
                //Hades.loadShortcut(53, {id: inpatientNS._action.task_id, wf_action_id:inpatientNS._action.wf_action_id, wf_status_id:inpatientNS._action.to_state_id, type:'inpatient_treatment'});
        }
        // Medical Discharge
        else if (actionId == 79) {
            Hades.loadShortcut(65, {id: inpatientNS._action.task_id, wf_action_id:inpatientNS._action.wf_action_id, wf_status_id:inpatientNS._action.to_state_id, type:'inpatient_treatment_clinical'});
        }
        //Undo arrival
        else if (actionId==17){
            inpatientNS.openReason(inpatientNS.undoArrivalReasonModalHandler);

        }
        //Reopen
        else if (actionId==14){
            //inpatientNS.openReason(inpatientNS.VerifySlotStatus(inpatientNS.ReopenReasonModalHandler));
            inpatientNS.VerifySlotStatus();

        }
        //Undo Admission
        else if (actionId==117){
            //inpatientNS.openReason(inpatientNS.VerifySlotStatus(inpatientNS.ReopenReasonModalHandler));
            inpatientNS.openReason(inpatientNS.undoAdmissionReasonModalHandler);

        }
        // Other actions
        else {
            inpatientNS.executeGenericAction();
        }
    },
    // Execute Generic Action
    executeGenericAction:function () {
        workflow.executeGenericAction(inpatientNS._action, inpatientNS._callback, inpatientNS._row);
    },

    isSurgeryOpenValidateDischarge: function () {
        var params = {
            treatment_id: inpatientNS._action.task_id
        }

        $.get('/inpatient/management/is_surgery_open_validate_discharge', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (JSON.parse(data).result == 't') {
                    bootbox.alert(GlobalTranslations['APP_LABEL.2494']);
                } else {
                    Hades.loadShortcut(53, {id: inpatientNS._action.task_id, wf_action_id:inpatientNS._action.wf_action_id, wf_status_id:inpatientNS._action.to_state_id, type:'inpatient_treatment'});
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                inpatientNS._callback(false, inpatientNS._action, inpatientNS._row);
            });

    },
    // Open Reason
    openReason:function (callback) {

        var params = {
            task_id:inpatientNS._action.task_id,
            wf_id:inpatientNS._action.wf_id,
            wf_status_id:inpatientNS._action.to_state_id,
            wf_action_id:inpatientNS._action.wf_action_id};

        $.get('/modal/generic_reason_window', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#generic-reason-modal-ct').bind('genericReasonConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                inpatientNS._callback(false, inpatientNS._action, inpatientNS._row);
            });
    },
    // Cancel Requisition
    cancelReasonModalHandler:function (event, data) {
        $.fancybox.close(true);

        var params = {
            task_id:inpatientNS._action.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            cancel_date:data.date,
            cancel_hour:data.hour,
            wf_id:inpatientNS._row.wf_id,
            wf_status_id:inpatientNS._row.wf_status_id,
            wf_action_id:inpatientNS._action.wf_action_id};

        $.post('/inpatient/management/cancel_inpatient', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    inpatientNS._callback(false, inpatientNS._action, inpatientNS._row);
                } else {
                    inpatientNS._callback(true, inpatientNS._action, inpatientNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                inpatientNS._callback(false, inpatientNS._action, inpatientNS._row);
            });
    },

    undoArrivalReasonModalHandler:function (event, data) {
        $.fancybox.close(true);

        var params = {
            task_id:inpatientNS._action.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            cancel_date:data.date,
            cancel_hour:data.hour,
            wf_id:inpatientNS._row.wf_id,
            wf_status_id:inpatientNS._row.wf_status_id,
            wf_action_id:inpatientNS._action.wf_action_id};

            debug.log('Inside execute action - undoArrivalReasonModalHandler');

            $.post('/inpatient/management/undo_arrival_inpatient', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    inpatientNS._callback(false, inpatientNS._action, inpatientNS._row);
                } else {
                    inpatientNS._callback(true, inpatientNS._action, inpatientNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                inpatientNS._callback(false, inpatientNS._action, inpatientNS._row);
            });



    },

    // Cancel Requisition
    rejectReasonModalHandler:function (event, data) {
        $.fancybox.close(true);

        var params = {
            task_id:inpatientNS._action.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            cancel_date:data.date,
            cancel_hour:data.hour,
            wf_id:inpatientNS._row.wf_id,
            wf_status_id:inpatientNS._row.wf_status_id,
            wf_action_id:inpatientNS._action.wf_action_id};

        $.post('/inpatient/management/reject_inpatient', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    inpatientNS._callback(false, inpatientNS._action, inpatientNS._row);
                } else {
                    inpatientNS._callback(true, inpatientNS._action, inpatientNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                inpatientNS._callback(false, inpatientNS._action, inpatientNS._row);
            });
    },

    // Verify if slot is available/planned/unavailable.
    VerifySlotStatus:function () {

        var _callback = function() { inpatientNS.openReason(inpatientNS.reopenReasonModalHandler); };

        var params = {
            task_id:inpatientNS._action.task_id,
            wf_id:inpatientNS._action.wf_id};

        $.get('/physical_space/get_slot_status_info', params, null, "json")
            .done(function (data, status, xhr) {

                var _slot_wf_status_id = parseInt(data.slot_wf_status_id);
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (_slot_wf_status_id == globalConstants.STATUS_SLOT_OCCUPIED){
                    bootbox.alert(GlobalTranslations.slotOcuppied);
                }
                else if (_slot_wf_status_id == globalConstants.STATUS_SLOT_PLANNED){

                    bootbox.confirm(GlobalTranslations.slotPlanned, function (result) {
                        if (result){
                            _callback();
                        }

                    });
                }
                else if (_slot_wf_status_id == globalConstants.STATUS_SLOT_AVAILABLE){
                    _callback();
                }

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                inpatientNS._callback(false, inpatientNS._action, inpatientNS._row);
            });
    },

    reopenReasonModalHandler: function(event, data){
        $.fancybox.close(true);

        debug.log("reopenReasonModalHandler params", data);

        var params = {
            task_id:inpatientNS._action.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            reopen_date:data.date,
            reopen_hour:data.hour,
            wf_id:inpatientNS._row.wf_id,
            wf_status_id:inpatientNS._row.wf_status_id,
            wf_action_id:inpatientNS._action.wf_action_id};

        $.post('/inpatient/management/reopen_inpatient', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();

                    inpatientNS._callback(false, inpatientNS._action, inpatientNS._row);
                } else {
                    //Hades.reloadContextualHeader();
                    inpatientNS._callback(true, inpatientNS._action, inpatientNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                inpatientNS._callback(false, inpatientNS._action, inpatientNS._row);
            });

    },

    undoAdmissionReasonModalHandler:function (event, data) {
        $.fancybox.close(true);

        var params = {
            task_id:inpatientNS._action.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            undo_admission_date:data.date,
            undo_admission_hour:data.hour,
            wf_id:inpatientNS._row.wf_id,
            wf_status_id:inpatientNS._row.wf_status_id,
            wf_action_id:inpatientNS._action.wf_action_id};

        $.post('/inpatient/management/undo_admission_inpatient', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    //Hades.showError(Hades.genericErrorMsg(), data.error);
                    bootbox.alert(data.error);
                    Hades.hideLoading();
                    inpatientNS._callback(false, inpatientNS._action, inpatientNS._row);
                } else {
                    inpatientNS._callback(true, inpatientNS._action, inpatientNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                //Hades.showError(error, xhr.responseText, xhr, status, error);
                bootbox.alert(data.error);
                Hades.hideLoading();
                inpatientNS._callback(false, inpatientNS._action, inpatientNS._row);
            });



    }
};